import axios from "axios"

export const apiEsqueceuSenha = async (user, { setControlaBooleano, setErroLogin }) => {

    try {
        if (user != null) {
            setControlaBooleano((prevState) => ({
                ...prevState,
                enviouLink: true
            }));
            setErroLogin(false)
            const res = await axios.post(`${process.env.REACT_APP_URL_CREDENCIAL}/api/security/forgot-password`, { user: user })
            if (res.status === 200) {
                // console.log("res", res)
                if (res.data.status === 'usuario inexistente') {
                    setControlaBooleano((prevState) => ({
                        ...prevState,
                        emailIvalido: true
                    }));
                } else {
                    setControlaBooleano((prevState) => ({
                        ...prevState,
                        emailIvalido: false
                    }));
                }
            }
        } else {
            setErroLogin(true)
        }
    } catch (error) {
        console.error("Erro ao trocar de senha", error);
    }

}